document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('contactForm');
    const fileUploadBtn = document.querySelector('.file-upload-btn');
    const fileInput = document.getElementById('file-upload');
    const submitBtn = form.querySelector('button[type="submit"]');
    const confirmBtn = form.querySelector('.btn-confirm');
    const editBtn = form.querySelector('.btn-edit');
    const inputs = form.querySelectorAll('input, textarea');

    editBtn.classList.add('d-none');
    submitBtn.classList.add('d-none');

    // Alert elements
    const errorAlert = document.getElementById('error-alert');
    const errorText = document.getElementById('error-text');

    // API Configuration
    const API_ENDPOINT = window.apiUrl + '/api/contact';

    // Customer type elements
    const individualRadio = document.getElementById('individual');
    const companyRadio = document.getElementById('company');
    const companyInputs = document.querySelectorAll('.company-fields input');
    const customerTypeError = document.getElementById('customer-type-error');

    // Hide customer type error by default
    if (customerTypeError) {
        customerTypeError.classList.add('d-none');
    }

    function setInputsDisabled(disabled) {
        inputs.forEach(input => {
            input.disabled = disabled;
        });
    }

    // Customer type toggle functionality
    function toggleCustomerType() {
        if (individualRadio.checked) {
            // Enable company fields as not required
            companyInputs.forEach(input => {
                input.disabled = false;
                input.removeAttribute('required');
                input.classList.remove('is-invalid', 'is-valid');
            });

            document.querySelectorAll('.company-required-star').forEach(el => el.classList.add('d-none'));
        } else if (companyRadio.checked) {
            // Enable company fields as required
            companyInputs.forEach(input => {
                input.disabled = false;
                input.setAttribute('required', 'required');
            });

            document.querySelectorAll('.company-required-star').forEach(el => el.classList.remove('d-none'));
        }
        // Hide customer type error on change
        if (customerTypeError) {
            customerTypeError.classList.add('d-none');
        }
    }

    // Initialize customer type toggle
    toggleCustomerType();

    // Add event listeners for radio buttons
    individualRadio.addEventListener('change', toggleCustomerType);
    companyRadio.addEventListener('change', toggleCustomerType);

    // File upload functionality with file list display
    function createFileListElement() {
        let existingList = document.getElementById('uploaded-files-list');
        if (existingList) {
            return existingList;
        }

        const fileList = document.createElement('div');
        fileList.id = 'uploaded-files-list';
        fileList.className = 'uploaded-files-list mt-2';
        fileList.classList.add('d-none');

        // Insert after the file upload wrapper
        const uploadWrapper = document.querySelector('.file-upload-wrapper');
        uploadWrapper.insertAdjacentElement('afterend', fileList);

        return fileList;
    }

    function showErrorMessageFile(message) {
        const errorMsgFileEl = document.querySelector('#error-message-file');
        let msgHTML = `
            <div class="mt-2">
                <div class="text-danger">${message}</div>
            </div>
        `;

        errorMsgFileEl.innerHTML = msgHTML;
        errorMsgFileEl.classList.remove('d-none');
    }

    function hideErrorMessageFile() {
        const errorMsgFileEl = document.querySelector('#error-message-file');
        errorMsgFileEl.classList.add('d-none');
        errorMsgFileEl.innerHTML = '';
    }

    function updateFileList() {
        const fileList = createFileListElement();
        const files = fileInput.files;

        if (files.length === 0) {
            fileList.classList.add('d-none');
            fileList.innerHTML = '';
            return;
        }

        let listHTML = '';

        Array.from(files).forEach((file, index) => {
            const fileSize = (file.size / 1024).toFixed(1) + ' KB';
            listHTML += `
                <div class="file-item d-flex justify-content-between align-items-center py-1">
                    <div class="file-info">
                        <i class="bi bi-file-earmark text-primary me-2"></i>
                        <span class="file-name">${file.name}</span>
                        <small class="file-size text-muted ms-2">(${fileSize})</small>
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-danger remove-file" data-index="${index}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                        </svg>
                    </button>
                </div>
            `;
        });

        fileList.innerHTML = listHTML;
        fileList.classList.remove('d-none');

        // Add event listeners to remove buttons
        fileList.querySelectorAll('.remove-file').forEach(btn => {
            btn.addEventListener('click', function() {
                const indexToRemove = parseInt(this.dataset.index);
                removeFileFromInput(indexToRemove);
            });
        });
    }

    function removeFileFromInput(indexToRemove) {
        const dt = new DataTransfer();
        const files = fileInput.files;

        for (let i = 0; i < files.length; i++) {
            if (i !== indexToRemove) {
                dt.items.add(files[i]);
            }
        }

        fileInput.files = dt.files;
        updateFileList();
    }

    fileUploadBtn.addEventListener('click', function() {
        fileInput.click();
    });

    fileInput.addEventListener('change', function() {
        hideErrorMessageFile();
        const files = this.files;
        if (files.length > 1) {
            this.value = '';
            updateFileList();
            showErrorMessageFile('一度にアップロードできるのは1つのファイルのみです。');
            return;
        }

        if (files.length === 1) {
            const file = files[0];
            const allowedExtension = /\.(zip|png|jpeg|jpg|pdf|psd|eps|ai)$/i;
            // 10 MB
            const maxSize = 10 * 1024 * 1024; 

            if (!allowedExtension.test(file.name)) {
                this.value = '';
                updateFileList();
                showErrorMessageFile('無効なファイル形式です。許可されている形式: .zip, .png, .jpeg, .jpg, .pdf, .ai, .psd, .eps');
                return;
            }

            if (file.size > maxSize) {
                this.value = '';
                updateFileList();
                showErrorMessageFile('ファイルサイズは10MB以下にしてください。');
                return;
            }
        }

        updateFileList();
    });

    // Show Bootstrap Alert using classes
    function showAlert(type, message = '') {
        hideAlerts();

        if (type === 'error') {
            if (message) {
                errorText.textContent = message;
            }
            errorAlert.classList.remove('d-none');
            errorAlert.classList.add('d-block', 'show');
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });

        setTimeout(() => {
            hideAlerts();
        }, 8000);
    }

    // Hide Bootstrap Alerts using classes
    function hideAlerts() {
        errorAlert.classList.remove('show', 'd-block');
        errorAlert.classList.add('d-none');
    }

    // Handle Bootstrap alert close buttons
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('btn-close')) {
            const alert = e.target.closest('.alert');
            if (alert) {
                alert.classList.remove('show', 'd-block');
                alert.classList.add('d-none');
            }
        }
    });

    function validateRegularName(input) {
        const value = input.value.replace(/[^\p{L}\s]/gu, '');
        input.value = value;
    }

    const firstName = document.getElementById('first_name');
    const lastName = document.getElementById('last_name');
    if (firstName) {
        firstName.addEventListener('input', () => validateRegularName(firstName));
    }
    if (lastName) {
        lastName.addEventListener('input', () => validateRegularName(lastName));
    }

    function validatePhoneNumber(input) {
        const value = input.value.replace(/[^0-9]/g, '');
        input.value = value;
    }

    const phone1 = document.getElementById('phone1');
    const phone2 = document.getElementById('phone2');
    const phone3 = document.getElementById('phone3');
    [phone1, phone2, phone3].forEach(input => {
        if (input) {
            input.addEventListener('input', () => validatePhoneNumber(input));
        }
    });


    // Submit form to API
    async function submitFormToAPI(formData) {
        try {
            const response = await fetch(API_ENDPOINT, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const result = await response.json();
                return { success: true, data: result };
            } else {
                let errorData = {};
                try {
                    errorData = await response.json();
                } catch (e) {}

                const errorMessage = errorData.message || `HTTP Error: ${response.status} ${response.statusText}`;
                return {
                    success: false,
                    error: errorMessage
                };
            }
        } catch (error) {
            return {
                success: false,
                error: `Network error: ${error.message}`
            };
        }
    }

    // Reset form to initial state
    function resetFormToInitial() {
        form.classList.remove('was-validated');
        form.querySelectorAll('input, textarea, select').forEach(input => {
            input.classList.remove('is-invalid', 'is-valid');
        });

        form.reset();

        individualRadio.checked = true;
        companyRadio.checked = false;

        toggleCustomerType();

        if (customerTypeError) {
            customerTypeError.classList.add('d-none');
        }

        fileInput.value = '';
        const fileList = document.getElementById('uploaded-files-list');
        if (fileList) {
            fileList.classList.add('d-none');
            fileList.innerHTML = '';
        }
    }

    // Validate
    function isValidForm() {
        hideAlerts();

        let isValid = true;

        form.querySelectorAll('.form-control').forEach(input => {
            input.classList.remove('is-invalid', 'is-valid');
        });

        if (customerTypeError) {
            customerTypeError.classList.add('d-none');
        }

        // Validate required fields
        const requiredFields = form.querySelectorAll('[required]');

        requiredFields.forEach(field => {
            if (!field.checkValidity()) {
                field.classList.add('is-invalid');
                field.classList.remove('is-valid');
                isValid = false;
            } else {
                field.classList.remove('is-invalid');
                field.classList.add('is-valid');
            }
        });

        // Email validation
        const emailField = document.getElementById('email');
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailField.value && !emailPattern.test(emailField.value)) {
            emailField.classList.add('is-invalid');
            emailField.classList.remove('is-valid');
            isValid = false;
        }

        // Regex Katakana validation
        const katakanaRegex = /^[\u30A0-\u30FF\s]+$/;
        const companyNameKata = document.getElementById('company_name_kata');
        const firstNameKata = document.getElementById('first_name_kata');
        const lastNameKata = document.getElementById('last_name_kata');

        [companyNameKata, firstNameKata, lastNameKata].forEach(field => {
            if (field.value) {
                const katakanaTest = katakanaRegex.test(field.value);
                if (katakanaTest) {
                    field.classList.remove('is-invalid');
                    field.classList.add('is-valid');
                } else {
                    field.classList.remove('is-valid');
                    field.classList.add('is-invalid');
                    isValid = false;
                }
            }
        });

        // Message length validation
        const messageField = document.getElementById('message');
        if (messageField.value.length < 10) {
            messageField.classList.add('is-invalid');
            messageField.classList.remove('is-valid');
            isValid = false;
        }

        if (messageField.value.length > 5000) {
            messageField.classList.add('is-invalid');
            messageField.classList.remove('is-valid');
            isValid = false;
        }

        // Postal code validation
        const zipcode1 = document.getElementById('zipcode1');
        const zipcode2 = document.getElementById('zipcode2');
        if (zipcode1.value && !/^\d{3}$/.test(zipcode1.value)) {
            zipcode1.classList.add('is-invalid');
            zipcode1.classList.remove('is-valid');
            isValid = false;
        }
        if (zipcode2.value && !/^\d{4}$/.test(zipcode2.value)) {
            zipcode2.classList.add('is-invalid');
            zipcode2.classList.remove('is-valid');
            isValid = false;
        }

        // Phone number validation
        const phoneInputs = [phone1, phone2, phone3];
        const phoneNumberPattern = /^[0-9]+$/;
        let phoneValid = true;
        phoneInputs.forEach(input => input.classList.remove('is-invalid'));

        if (!phone1.value || !phoneNumberPattern.test(phone1.value)) phoneValid = false;
        if (!phone2.value || !phoneNumberPattern.test(phone2.value)) phoneValid = false;
        if (!phone3.value || !phoneNumberPattern.test(phone3.value)) phoneValid = false;

        if (!phoneValid) {
            phoneInputs.forEach(input => input.classList.remove('is-valid'));
            phoneInputs.forEach(input => input.classList.add('is-invalid'));
            isValid = false;
        }

        return isValid;
    };

    // Invalid form
    function handleInvalidForm() {
        form.classList.add('was-validated');
        const firstError = form.querySelector('.is-invalid');
        if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstError.focus();
        }
    }

    // disbale icon remove file .zip
    function setFileRemoveButtonsDisabled(disabled) {
        const removeButtons = document.querySelectorAll('#uploaded-files-list .remove-file');
        removeButtons.forEach(btn => {
            btn.disabled = disabled;
            if (disabled) {
                btn.classList.add('disabled');
                btn.style.pointerEvents = 'none';
                btn.setAttribute('aria-disabled', 'true');
            } else {
                btn.classList.remove('disabled');
                btn.style.pointerEvents = '';
                btn.removeAttribute('aria-disabled');
            }
        });
    }

    // Confirm
    confirmBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (isValidForm()) {
            setInputsDisabled(true);

            confirmBtn.classList.add('d-none');
            editBtn.classList.remove('d-none');
            submitBtn.classList.remove('d-none');

            setFileRemoveButtonsDisabled(true);

            form.classList.remove('was-validated');
        } else {
            handleInvalidForm();
        }
    });

    // Edit
    editBtn.addEventListener('click', function(e) {
        e.preventDefault();
        setInputsDisabled(false);

        editBtn.classList.add('d-none');
        submitBtn.classList.add('d-none');
        confirmBtn.classList.remove('d-none');

        setFileRemoveButtonsDisabled(false);
    });

    // Submit
    form.addEventListener('submit', async function(event) {
        event.preventDefault();
        event.stopPropagation();

        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>送信中...';

        const formData = new FormData();

        inputs.forEach(input => {
            if (input.type === 'checkbox' && !input.checked) return;
            if (input.type === 'radio' && !input.checked) return;
            if (input.type === 'file') {
                for (let i = 0; i < input.files.length; i++) {
                    formData.append('file', input.files[i]);
                }
            } else {
                formData.append(input.name, input.value);
            }
        });

        const result = await submitFormToAPI(formData);

        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.originalText || '送信';

        if (result.success) {
            // サンクスページへリダイレクト
            // URLパラメータを追加して、どのフォームから来たかを識別可能にする
            const thanksPageUrl = '/pages/thanks-inquiries?from=contact';
            window.location.href = thanksPageUrl;
            
            // 元の処理はコメントアウト（必要に応じて削除可能）
            /*
            form.classList.add('d-none');
            hideAlerts();

            const successUI = document.getElementById('success-box');
            if (successUI) {
                successUI.classList.remove('d-none');
            }

            window.scrollTo({ top: 0, behavior: 'smooth' });
            */

            setTimeout(() => {
                resetFormToInitial();
                setInputsDisabled(false);
                editBtn.classList.add('d-none');
                submitBtn.classList.add('d-none');
                confirmBtn.classList.remove('d-none');
            }, 100);
        } else {
            showAlert('error');
        }
    });

    form.addEventListener('input', function(event) {
        const field = event.target;
        if (field.matches('[required]') || field.value !== '') {
            if (field.checkValidity()) {
                field.classList.remove('is-invalid');
                field.classList.add('is-valid');
            } else {
                field.classList.remove('is-valid');
                field.classList.add('is-invalid');
            }
        }
    });

    if (submitBtn) {
        submitBtn.dataset.originalText = submitBtn.textContent;
    }

    // handle zipcode
    const zip1 = document.getElementById('zipcode1');
    const zip2 = document.getElementById('zipcode2');
    const prefectureField = document.getElementById('prefecture');
    const cityField = document.getElementById('city');
    const addressDetailsField = document.getElementById('address_details');
    const addressLookupError = document.getElementById('address-lookup-error');

    // 郵便番号から住所が引けなかったとき（データに無い・読み込み失敗）は、案内を出して手入力してもらう
    if (window.AjaxZip3) {
        AjaxZip3.onFailure = function() {
            addressLookupError.classList.remove('d-none');
            // ページを開いたときの自動入力（focus なし）では、フォーカスを動かさない
            if (AjaxZip3.ffocus) {
                prefectureField.focus();
            }
        };
    }

    function validatePostalCode(input, maxLength) {
        const value = input.value.replace(/[^0-9]/g, '');
        input.value = value;
        
        fillAddress(true);
    }

    function fillAddress(shouldFocus) {
        if (zip1.value.length === 3 && zip2.value.length === 4) {
            addressLookupError.classList.add('d-none');
            AjaxZip3.zip2addr('zipcode1', 'zipcode2', 'prefecture', 'city', 'address_details', null, shouldFocus);
        }
    }

    zip1.addEventListener('input', () => validatePostalCode(zip1, 3));
    zip2.addEventListener('input', () => validatePostalCode(zip2, 4));

    // 郵便番号だけ登録済みの会員向けに、開いた時点で住所が空なら1回だけ自動入力する（入力済みの町・番地は上書きしない）
    if (!prefectureField.value && !cityField.value && !addressDetailsField.value) {
        fillAddress(false);
    }
});